import React from "react";

const Content = ({ containerClassName, ...props }) => {
  const defaultContainer = `container-xl wide-${window.location.pathname.split("/")[2] === "invest" ? "lg" : "xl"}`;
  const containerClass = containerClassName || defaultContainer;
  
  return (
    <div className="nk-content nk-content-fluid">
      <div className={containerClass}>
        <div className="nk-content-inner">
          <div className="nk-content-body">
            {!props.page ? props.children : null}
            {props.page === "component" ? (
              <div className="components-preview wide-md mx-auto">{props.children}</div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Content;
